import Step from "rivals/components/pages/Registration/Steps/Step";
import TermsOfService from "rivals/components/pages/Registration/TermsOfService";
import DebitAgreement from "rivals/components/shared/Form/DebitAgreement/index";
import SubscriptionAgreement from "rivals/components/shared/Subscription/SubscriptionAgreement";
import SubscriptionPricing from "rivals/components/shared/Subscription/SubscriptionPricing";
import styles from "./CompletePurchase.module.scss";
import strings from "./strings";
import { Props } from "./types";

const { completePurchase, completePurchaseButton, selectSitePrompt } = strings;

function CompletePurchaseStep({
  address,
  buttonDisabled,
  debitAgreedState,
  debitTerms,
  isDebit,
  payPalEmail,
  selectedPlan,
  stepNumber,
  submit,
  promoCodeValue,
  selectedAddOn,
  selectedSite,
  tax,
  tosAgreements,
  setIsAutoRenewAgreed,
  isAutoRenewAgreed,
  requiresAutoRenewalOptIn
}: Props): JSX.Element {
  let debitAgreement: JSX.Element | undefined;

  if (isDebit && debitAgreedState) {
    debitAgreement = (
      <DebitAgreement
        className={styles.terms}
        debitAgreedState={debitAgreedState}
        debitTerms={debitTerms}
      />
    );
  }

  let body;

  if (selectedSite.subscribable) {
    body = (
      <SubscriptionPricing
        addOn={selectedAddOn}
        address={address}
        isPayPal={!!payPalEmail}
        isValid={!buttonDisabled}
        planType={selectedPlan}
        promoCodeValue={promoCodeValue}
        selectedSite={selectedSite}
        tax={tax}
      />
    );
  } else {
    body = <div className={styles.sitePrompt}>{selectSitePrompt}</div>;
  }

  return (
    <div>
      <Step stepNumber={stepNumber} title={completePurchase}>
        <>
          {body}
          {requiresAutoRenewalOptIn && (
            <SubscriptionAgreement
              isAutoRenewAgreed={isAutoRenewAgreed}
              onAutoRenewChange={(): void => {
                setIsAutoRenewAgreed(!isAutoRenewAgreed);
              }}
            />
          )}
          <TermsOfService
            buttonDisabled={buttonDisabled}
            debitAgreement={debitAgreement}
            handleSubmit={submit}
            isPaid={true}
            submitButtonText={completePurchaseButton}
            tosAgreements={tosAgreements}
          />
        </>
      </Step>
    </div>
  );
}

export default CompletePurchaseStep;
